import { render, staticRenderFns } from "./mentionstf.vue?vue&type=template&id=ebcf8ea4&"
import script from "./mentionstf.vue?vue&type=script&lang=js&"
export * from "./mentionstf.vue?vue&type=script&lang=js&"
import style0 from "./mentionstf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports